import React, { forwardRef, useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { toast } from '@mesh.ai/rabbit';
import { useQueryClient } from '@tanstack/react-query';

import { Ellipsis, Overflow, Trash } from 'assets/assetsV1/iconComponents';

import { sendRespondedToFeedbackRequest } from 'constants/mixpanelHelper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { deleteReceivedFeedbackData } from 'services/continuousFeedback';

import { Button } from 'uiToolkitV1/Button';
import { Menu, MenuButton, MenuItem, MenuList } from 'uiToolkitV1/MenuV2';

export const DrawerKebabMenu = ({ feedbackId, handleClose }) => {
  const queryClient = useQueryClient();

  const deleteFeedback = async (e) => {
    e?.stopPropagation();

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const res = await deleteReceivedFeedbackData({ feedbackId });
      sendRespondedToFeedbackRequest({
        eventProperties: {
          response: 'Delete',
        },
      });
      handleClose();
      await queryClient.invalidateQueries({ queryKey: ['CFTable'] });
      await queryClient.invalidateQueries({ queryKey: ['CFTabs'] });
      await queryClient.invalidateQueries({ queryKey: [REACT_QUERY_KEYS.mySummary.mySummaryFeedback] });
      await queryClient.invalidateQueries({ queryKey: [REACT_QUERY_KEYS.ReviewPeriodSummaryFeedback] });
      toast.success('Feedback deleted successfully');
    } catch (err) {
      console.error('Error deleting the feedback: ', err);
      toast.error('Error deleting the feedback');
    }
  };

  const menuOptions = useMemo(
    () => [
      {
        label: 'Delete',
        onClick: deleteFeedback,
        Icon: Trash,
        enabled: feedbackId,
      },
    ],
    [feedbackId, deleteFeedback]
  );

  return (
    <Box pt={4}>
      <Menu>
        <MenuButton
          // eslint-disable-next-line react/no-unstable-nested-components
          as={forwardRef((props, ref) => (
            // eslint-disable-next-line react/no-unstable-nested-components
            <Button ref={ref} variant="tertiary" p={0} {...props} EndIcon={() => <Overflow boxSize="24px" />} />
          ))}
          icon={<Ellipsis />}
        />
        <MenuList>
          {menuOptions.map((option, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <MenuItem key={index} onClick={option.onClick}>
              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};
